import React from 'react';
import {twMerge} from 'tailwind-merge';

import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import elementsTesIds from '../../test/consts/elementsTesIds';
import {twx} from '../../utils/tailwindUtils';
import {Article} from '../DataDisplay';
import {HelpBlueIcon, LocationBlueIcon} from '../Icons';
import {ContentWrapper} from '../Layout';

const SupportAndStoreTemplate = (props) => {
    const {className, isTitleVisible, onNearestStoreClick, isConnectCare, supportTestId, storeTestId} = props;
    const localizedStrings = getLocalizedStrings();
    const supportUrl = appConfig.getDcsSupportUrlFormatted();
    const storeUrl = appConfig.getIqosStoreUrlFormatted();
    const isSupportTitleVisible = supportUrl || storeUrl;

    return (
        <div className='w-full'>
            <ContentWrapper>
                {isSupportTitleVisible && isTitleVisible && (
                    <h2 className='mb-10 mt-10 text-24 md:mt-16'>
                        {localizedStrings[localizationKeys.SUPPORT_OTHER_WAYS_TITLE_TEXT]}
                    </h2>
                )}
                <div
                    className={twx(
                        'flex w-full flex-col items-center gap-10 md:w-auto md:flex-row md:gap-6',
                        {'mt-[60px]': !isSupportTitleVisible || !isTitleVisible},
                        className
                    )}
                >
                    {supportUrl && (
                        <Section
                            icon={<HelpBlueIcon />}
                            titleKey={localizationKeys.SUPPORT_CONTACT_US_TITLE_TEXT}
                            buttonTo={supportUrl}
                            buttonTextKey={
                                isConnectCare
                                    ? localizationKeys.POPUP_CARE_CONTACT_DEVICE_ACTION_BUTTON_TEXT
                                    : localizationKeys.SUPPORT_CONTACT_US_BUTTON_TEXT
                            }
                            testId={
                                supportTestId
                                    ? supportTestId
                                    : elementsTesIds.PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_CONTACT_US
                            }
                        />
                    )}
                    {storeUrl && (
                        <Section
                            icon={<LocationBlueIcon />}
                            titleKey={localizationKeys.SUPPORT_FIND_STORE_TITLE_TEXT}
                            buttonTo={onNearestStoreClick ? undefined : storeUrl}
                            onClick={onNearestStoreClick ? onNearestStoreClick : undefined}
                            buttonTextKey={localizationKeys.SUPPORT_FIND_STORE_BUTTON_TEXT}
                            testId={
                                storeTestId
                                    ? storeTestId
                                    : elementsTesIds.PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_CONTACT_US
                            }
                        />
                    )}
                </div>
            </ContentWrapper>
        </div>
    );
};

const Section = (props) => {
    const {icon, titleKey, buttonTo, className, buttonTextKey, onClick, testId} = props;

    return (
        <Article
            icon={icon}
            className='w-full md:self-stretch'
            titleClassName={twMerge('text-18 mt-3 md:mt-4 flex-1', className)}
            titleKey={titleKey}
            buttonSecondary={{
                isTargetBlank: true,
                isExternalLink: true,
                to: buttonTo,
                onClick,
                className: 'mt-6 sm:min-w-[312px]',
                textKey: buttonTextKey,
                testId,
            }}
        />
    );
};

export default SupportAndStoreTemplate;
